if (!customElements.get('products-slider')) {   
  class ProductsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }
  
    connectedCallback() {
      this.initSlider();
    }
  
    initSlider(){
      if (!this.querySelector('[data-slider]')) return;
      
      this.options = {
        slidesPerView: 2,
        loop: false,
        autoplay: true,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 30,
          }
        }
      }
  
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options
      )
    }
  }
  
  customElements.define('products-slider', ProductsSlider);
}
